<template>
    <div style="position:relative" :class="{'open':openSuggestion}">
        <input class="form-control"
            type="text"
            :value="value"
            @input="updateValue($event.target.value)"
            @keydown.enter="enter"
            @keydown.down="down"
            @keydown.up="up"
            />
        <ul :class="menuClass" >
            <li
                v-for="(suggestion, index) in matches"
                :key="index"
                :class="{'active': isActive(index)}"
                @click="suggestionClick(index)"
            >
                <a href="#">{{ suggestion.code }} <small>{{ suggestion.name }} - {{ suggestion.city }}</small></a>
            </li>
        </ul>
        
    </div>
</template>

<script>
import axios from "axios";

export default {
    data() {
        return {
            open: false,
            current: 0,
            suggestions:[],
        }
    },
    props: {
        value: {
            type: String,
            require: true,
        },
    },
    computed: {
        matches() {
            return this.suggestions

        },
        openSuggestion() {
            return this.matches.length === 0 && this.open === true
        },
        menuClass() {
            if (this.open) {
                return "dropdown-menu.show"
            } else {
                return "dropdown-menu"
            }
        }
    },
    methods: {
        updateValue(value) {
            if (value.length > 1) {
                axios.get("https://gc.wandrhost.com/btsairports.php?term=" + value).then((r) => {
                    this.suggestions = r.data
                    
                    if (this.open === false) {
                        this.open = true
                        this.current = 0
                    }
                    this.$emit('input', value)
                }).catch((error) => {
                    console.log(error.response)
                })
            }
        },
        enter() {
            this.$emit('input', this.matches[this.current].code)
            this.open = false
        },
        up() {
            if (this.current > 0) {
                this.current--
            }
        },
        down() {
            if (this.current < this.matches.length - 1) {
                this.current++
            }
        },
        isActive(index) {
            return index === this.current
        },
        suggestionClick(index) {
            this.$emit('input', this.matches[index].code)
            this.open = false
        }
    }
}
</script>
